import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * Componente de información de contacto, este se usa en la pagina de ayuda
 * @param {object} textsDescarga - objeto con los textos de interfaz
 * @returns {JSX.Element} ContactInfo
 */
export const ContactInfo = ({ textsDescarga }) => {
    return (

        <div className='datos-de-contacto'>
            <img src='../img/eyex-pregunta.png' className='instrucciones-eyex' alt={'eyex-pregunta.png'} />
            <h3 className='text-center  text-lg-left' >{textsDescarga?.titulo || 'Datos de contacto America latina'}</h3>
            <div className='mt-3 row justify-content-center justify-content-lg-start m-0'>
                <Icon icon="ic:round-email" width={30} />
                <a href={`mailto:${textsDescarga?.correo || 'contacto@makemake.com.co'}`} className='focusable-secondary ml-2'> {textsDescarga?.correo || 'contacto@makemake.com.co'}</a>
            </div>
            <div className='mt-3 row m-0 justify-content-center justify-content-lg-start align-items-start'>
                <Icon icon="ri:whatsapp-fill" width={30} />
                <div className='ml-2'>
                    <a
                        href={textsDescarga?.num_uno?.link || "https://wa.link/vuju91"}
                        className="focusable-secondary d-block"
                    >
                        +{textsDescarga?.num_uno?.numero || '57 313 4509992'}
                    </a>
                    <a
                        href={textsDescarga?.num_dos?.link || "https://wa.link/aozzbk"}
                        className="focusable-secondary d-block"
                    >
                        +{textsDescarga?.num_dos?.numero || '57 350 2367037'}
                    </a>
                </div>
            </div>
            <h3 className='text-center  text-lg-left mt-3' >{textsDescarga?.usa?.titulo || 'Datos de contacto Estados Unidos'}</h3>
            <div className='mt-3 row justify-content-center justify-content-lg-start m-0'>
                <Icon icon="ic:round-email" width={30} className='mt-1' />
                <div>
                    <a href={`mailto:info@chinita.online`} className='focusable-secondary ml-2'> info@chinita.online</a>
                    <br />
                    <a href={`mailto:contacto@makemake.com.co`} className='focusable-secondary ml-2'> contacto@makemake.com.co</a>
                </div>
            </div>
            <div className='mt-3 row m-0 justify-content-center justify-content-lg-start align-items-start'>
                <Icon icon="ic:baseline-local-phone" width={30} />
                <div className='ml-2'>
                    <p
                        className="focusable-secondary d-block"
                    >
                        {`+1 (310) 690 0297`}
                    </p>
                </div>
            </div>
        </div>
    )
}